export const apiSettings = {
  arraysToReturnInValidOrder: [
    {
      keyName: "provisions",
      returnProperty: "index",
    },
  ],
};
